import React from 'react'
import Layout from 'src/components/layouts'
import Csrf from 'src/services/Csrf'
import Recaptcha from 'src/services/Recaptcha'
import ContactUs from 'src/components/pages/BrandPages/ContactUs'
import { APP_BASE_PATH } from 'src/common/constants'
import { OrganizationJsonLd } from 'next-seo'

export async function getServerSideProps(context) {
  /* const { req } = context

  const { getIpFromReq, isCrawler: is_crawler } = await import(
    '@achieve/cx-request-checks'
  )

  const isCrawler = is_crawler(req?.headers?.['user-agent'], getIpFromReq(req)) */

  return {
    props: {
      isCrawler: false,
      csrfToken: Csrf.getInstance().createToken(),
      recaptchaKey:
        process.env.RECAPTCHA_ENABLED === 'true'
          ? Recaptcha.getInstance().getKey()
          : null,
    },
  }
}

const Contact = () => {
  const JSON_LD_DATA = {
    type: 'Organization',
    id: `${APP_BASE_PATH()}/#organization`,
    logo: `${APP_BASE_PATH()}/next-assets/fdr-logo.webp`,
    legalName: 'Freedom Debt Relief LLC',
    name: 'Freedom Debt Relief',
    address: {
      streetAddress: '1875 S Grant St Ste 300',
      addressLocality: 'San Mateo',
      addressRegion: 'CA',
      postalCode: '94402',
      addressCountry: 'US',
    },
    contactPoints: [
      {
        type: 'ContactPoint',
        telephone: '+18009100065',
        contactType: 'customer service',
      },
    ],
    url: APP_BASE_PATH(),
  }

  return (
    <>
      <OrganizationJsonLd {...JSON_LD_DATA} />
      <Layout isBrandPage={true}>
        <ContactUs />
        <label
          htmlFor="g-recaptcha-response-100000"
          className="hidden"
          aria-hidden={true}
        >
          Recaptcha response
        </label>
      </Layout>
    </>
  )
}

export default Contact
